<div class="c-home__header">
	<tvcore-ivv-title title="Ons aanbod"></tvcore-ivv-title>

	<div class="c-home__header__buttons">
		<a [href]="RRN_APP_URL" class="c-btn--with-icon" target="_blank">
			Sociale Organisatie: vakantieganger toevoegen
			<tvcore-icon name="external-link"></tvcore-icon>
		</a>

		<span class="show-on-1024">|</span>

		<a [routerLink]="['/', 'favorites']" class="c-favorites-btn">
			{{ 'HOME.FAVORITES' | translate }}
			<tvcore-icon name="heart"></tvcore-icon>

			@if (favorites$ | async; as amount) {
				<span>{{ amount }}</span>
			}
		</a>
	</div>
</div>

<div class="c-hero-2 grey-container">
	<ivva-tabbar></ivva-tabbar>
	<ivva-main-filter></ivva-main-filter>

	<button (click)="showFilters.set(true)" class="c-btn-link">Meer filters</button>
</div>

<div class="content">
	<div class="side">
		@if (sideFilters$ | async; as sf) {
			@if (sf.length) {
				<div>
					<div class="c-filter-box__title">
						<p class="u-text--medium">{{ 'HOME.CHOSEN_FILTERS' | translate }}</p>
					</div>

					<div class="flex-row flex-wrap flex-gap--xxs">
						@for (filter of sf; track filter.item) {
							<button (click)="removeFilter(filter)" class="c-btn-tag">
								<p>{{ filter.pre ? (filter.pre | translate) : '' }}{{ filter.base + '.' + filter.item | translate }}</p>
								<tvcore-icon name="close"></tvcore-icon>
							</button>
						}
					</div>

					<button (click)="removeAllFilters()" class="c-btn-link u-m-top--xxs u-m-bottom--sm">{{ 'HOME.CLEAR_FILTERS' | translate }}</button>
				</div>
			}
		}

		<div [class.c-mobile-dialog--show]="showFilters()" class="c-mobile-dialog">
			<div class="c-mobile-dialog__content">
				<div class="c-mobile-dialog__header">
					<p class="u-title">{{ 'HOME.SIDE_FILTER.TITLE' | translate }}</p>
					<button (click)="showFilters.set(false)" class="c-btn-link">
						<tvcore-icon name="close"></tvcore-icon>
					</button>
				</div>

				@if (type$ | async; as type) {
					@if (type === OffersType.ACCOMMODATION) {
						<ivva-price-filter [type]="type" class="u-m-bottom--xs"></ivva-price-filter>
					} @else if (type === OffersType.DAYTRIP) {
						<ivva-price-filter [type]="type" class="u-m-bottom--xs"></ivva-price-filter>
					}
				}

				<ivva-side-filter></ivva-side-filter>

				<div class="c-mobile-dialog__footer">
					<button (click)="showFilters.set(false)" class="c-btn-link">{{ 'HOME.SIDE_FILTERS.CLOSE' | translate }}</button>
				</div>
			</div>
		</div>
	</div>

	<div class="main">
		<div class="main-header u-m-bottom--md">
			<p class="u-text--medium">
				@if (total$ | async; as total) {
					{{ 'HOME.SEARCH_RESULTS_AMOUNT' | translate: { total: total } }}
				} @else {
					@if (loading$ | async) {
					} @else {
						{{ 'HOME.SEARCH_RESULTS_AMOUNT' | translate: { total: 0 } }}
					}
				}
			</p>

			<div class="main-header__right">
				@if (view$ | async; as v) {
					@if (v === 'list') {
						@if (type$ | async; as type) {
							@if (type !== OffersType.ORGANIZED_HOLIDAY) {
								<button (click)="setView('map')" class="c-btn-link c-btn--with-icon">
									<tvcore-icon name="map"></tvcore-icon>
									{{ 'HOME.MAP_VIEW_BUTTON' | translate }}
								</button>
							}
						}

						<tvcore-dropdown (doSelect)="selectOrder($event)" [options]="orders$ | async" [selected]="selectedOrder$ | async" key="name">
							<ng-template #selectedTemplate let-option>
								{{ 'HOME.ORDER.' + option | translate }}
							</ng-template>

							<ng-template #optionTemplate let-option>
								{{ 'HOME.ORDER.' + option.name | translate }}
							</ng-template>
						</tvcore-dropdown>
					} @else {
						<button (click)="setView('list')" class="c-btn-link c-btn--with-icon">
							<tvcore-icon name="squares"></tvcore-icon>
							{{ 'HOME.LIST_VIEW_BUTTON' | translate }}
						</button>
					}
				}
			</div>
		</div>

		@if (view$ | async; as v) {
			@if (v === 'list') {
				@if (offers$ | async; as offers) {
					<div class="c-cards-grid">
						@if (showKampas$ | async) {
							<ivva-offer-card hardcoded="kampas"></ivva-offer-card>
						}

						@if (showDeLijn$ | async) {
							<ivva-offer-card hardcoded="delijn"></ivva-offer-card>
						}

						@for (offer of offers; track offer.id) {
							<ivva-offer-card [offer]="offer"></ivva-offer-card>
						}
					</div>
				}

				<div class="center">
					@if (nextAvailable$ | async) {
						<button (click)="loadMore()" [disabled]="loading$ | async" class="c-btn u-m-top--sm c-btn--full c-btn-loading">
							{{ 'HOME.LOAD_MORE' | translate }}

							<tvcore-icon name="loader"></tvcore-icon>
						</button>
					}
				</div>
			} @else {
				<ivva-map></ivva-map>
			}
		}
	</div>
</div>

<ivva-newsletter></ivva-newsletter>

<ivva-help></ivva-help>
